import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { PlayerProvider } from '@/context/PlayerContext';
import { AuthProvider } from '@/context/AuthContext';
import { FavoritesProvider } from '@/context/FavoritesContext';
import Home from '@/pages/Home';
import PlaylistDetail from '@/pages/PlaylistDetail';
import SearchPage from '@/pages/SearchPage';
import Admin from '@/pages/Admin';
import Onboarding from '@/pages/Onboarding';
import AuthCallback from '@/pages/AuthCallback';
import MeriPasand from '@/pages/MeriPasand';
import Player from '@/components/Player';
import Footer from '@/components/Footer';
import BackgroundLayer from '@/components/BackgroundLayer';
import AutoPlayHook, { AutoPlayToaster } from '@/components/AutoPlayHook';

const OnboardingGate = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    try {
      setSeen(localStorage.getItem('pkp_onboarded') === '1');
    } catch (e) {}
    setReady(true);
  }, []);
  if (!ready) return null;
  if (!seen) return <Navigate to="/welcome" replace />;
  return children;
};

// Detects the `#session_id=...` hash returned by Emergent OAuth and routes to AuthCallback.
// Uses useLocation() so it stays reactive when the router updates.
const AuthGate = ({ children }) => {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return children;
};

// Hide footer on onboarding and admin routes; show on all listener-facing pages.
const FooterGate = () => {
  const location = useLocation();
  const hideOn = ['/welcome', '/admin'];
  if (hideOn.some((p) => location.pathname.startsWith(p))) return null;
  return <Footer />;
};

function App() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch(() => {});
      });
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FavoritesProvider>
            <PlayerProvider>
              <BackgroundLayer />
              <AuthGate>
                <Routes>
                  <Route path="/welcome" element={<Onboarding />} />
                  <Route path="/" element={<OnboardingGate><Home /></OnboardingGate>} />
                  <Route path="/playlist/:slug" element={<OnboardingGate><PlaylistDetail /></OnboardingGate>} />
                  <Route path="/search" element={<OnboardingGate><SearchPage /></OnboardingGate>} />
                  <Route path="/meri-pasand" element={<OnboardingGate><MeriPasand /></OnboardingGate>} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
                <FooterGate />
              </AuthGate>
              <Player />
              <AutoPlayHook />
              <AutoPlayToaster />
            </PlayerProvider>
          </FavoritesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
